import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c584f81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splashscreen" }
const _hoisted_2 = { class: "splashscreen__wrapper" }

import { onMounted, ref } from 'vue';
import { IonImg, IonText } from '@ionic/vue';
import CarnotLogo from '@/assets/images/logo-carnot.png';
import CetimLogo from '@/assets/images/logo-cetim.png';
import QuatriumLogo from '@/assets/images/logo-quatrium.png';

const initialDelay = 250;
const timeInterval = 850;


export default /*#__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  emits: ['dismiss-request'],
  setup(__props, { emit: __emit }) {

const shouldDisplayCarnotLogo = ref<boolean>(false);
const shouldDisplayCetimLogo = ref<boolean>(false);
const shouldDisplayQuatriumLogo = ref<boolean>(false);

const emits = __emit;

onMounted(() => {
  setTimeout(() => {
    shouldDisplayCarnotLogo.value = true;
  }, initialDelay);
  setTimeout(() => {
    shouldDisplayCetimLogo.value = true;
  }, initialDelay + timeInterval);
  setTimeout(() => {
    shouldDisplayQuatriumLogo.value = true;
  }, initialDelay + timeInterval * 2);
  setTimeout(() => {
    emits('dismiss-request');
  }, initialDelay + timeInterval * 3);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IonImg), {
        class: _normalizeClass(['splashscreen__logo', { 'splashscreen__logo--visible': shouldDisplayCarnotLogo.value }]),
        src: _unref(CarnotLogo)
      }, null, 8, ["class", "src"]),
      _createVNode(_unref(IonImg), {
        class: _normalizeClass([
          'splashscreen__logo',
          'splashscreen__logo--cetim',
          { 'splashscreen__logo--visible': shouldDisplayCetimLogo.value },
        ]),
        src: _unref(CetimLogo)
      }, null, 8, ["class", "src"]),
      _createVNode(_unref(IonImg), {
        class: _normalizeClass(['splashscreen__logo', { 'splashscreen__logo--visible': shouldDisplayQuatriumLogo.value }]),
        src: _unref(QuatriumLogo)
      }, null, 8, ["class", "src"])
    ]),
    _createVNode(_unref(IonText), { class: "splashscreen__signature" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('splashscreen.signature')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})